import {RouterModule, Routes} from "@angular/router";
import { NgModule } from "@angular/core";

const routes: Routes = [
    {
      path: 'booking',
      loadChildren:() => import('./pages/booking/booking.module').then(m => m.BookingModule)
    },
    {
        path: 'init/:id/:idv',
        loadChildren:() => import('./pages/identification/identification.module').then(m => m.IdentificationModule)
    },
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
}) export class WatabilightRouting {}